export default {
  GETTERS: {
    GET_TERM: 'SEARCH/GET_TERM',
    GET_INPUT_TERM: 'SEARCH/GET_INPUT_TERM',
    GET_RECENTLY_SEARCHED_TERMS: 'SEARCH/GET_RECENTLY_SEARCHED_TERMS',
    GET_SHOULD_PREVENT_REDIRECT: 'SEARCH/GET_SHOULD_PREVENT_REDIRECT',
    GET_AGGREGATIONS: 'SEARCH/GET_AGGREGATIONS',
    GET_APPLIED_OPTIONS: 'SEARCH/GET_APPLIED_OPTIONS',
    GET_CURRENT_PAGE_CURSOR: 'SEARCH/GET_CURRENT_PAGE_CURSOR',
    GET_CURRENT_PAGE: 'SEARCH/GET_CURRENT_PAGE',
    GET_NEXT_PAGE_CURSOR: 'SEARCH/GET_NEXT_PAGE_CURSOR',
    GET_PREVIOUS_PAGES_CURSORS: 'SEARCH/GET_PREVIOUS_PAGES_CURSORS',
    GET_UPDATE_TRIGGERS: 'SEARCH/GET_UPDATE_TRIGGERS',
    GET_STATIC_OPTIONS: 'SEARCH/GET_STATIC_OPTIONS',
    GET_DEPARTMENT: 'SEARCH/GET_DEPARTMENT',
    GET_TOTAL_RESULTS: 'SEARCH/GET_TOTAL_RESULTS',
    GET_SELLER_FOR_SEARCH: 'SEARCH/GET_SELLER_FOR_SEARCH',
    GET_PAGES_COUNT: 'SEARCH/GET_PAGES_COUNT',
    GET_IS_FETCHING_PRODUCTS: 'SEARCH/GET_IS_FETCHING_PRODUCTS',
    GET_IS_FETCHING_AGGREGATIONS: 'SEARCH/GET_IS_FETCHING_AGGREGATIONS',
    GET_NAVIGATION_TYPE: 'SEARCH/GET_NAVIGATION_TYPE',
    GET_IS_STORE: 'SEARCH/GET_IS_STORE',
    GET_SEARCH_ID: 'SEARCH/GET_SEARCH_ID',
    GET_SEARCH_CONTEXT: 'SEARCH/GET_SEARCH_CONTEXT',
    GET_SELECTED_CONTEXT: 'SEARCH/GET_SELECTED_CONTEXT',
    GET_IS_PRODUCT_CONTEXT: 'SEARCH/GET_IS_PRODUCT_CONTEXT',
    GET_IS_HIGHLIGHTS_PANEL_VISIBLE: 'SEARCH/GET_IS_HIGHLIGHTS_PANEL_VISIBLE'
  },
  MUTATIONS: {
    SET_TERM: 'SEARCH/SET_TERM',
    SET_INPUT_TERM: 'SEARCH/SET_INPUT_TERM',
    SET_RECENTLY_SEARCHED_TERM: 'SEARCH/SET_RECENTLY_SEARCHED_TERM',
    SET_SHOULD_PREVENT_REDIRECT: 'SEARCH/SET_SHOULD_PREVENT_REDIRECT',
    SET_AGGREGATIONS: 'SEARCH/SET_AGGREGATIONS',
    SET_APPLIED_OPTIONS: 'SEARCH/SET_APPLIED_OPTIONS',
    SET_NEXT_PAGE_CURSOR: 'SEARCH/SET_NEXT_PAGE_CURSOR',
    SET_CURRENT_PAGE: 'SEARCH/SET_CURRENT_PAGE',
    SET_CURRENT_PAGE_CURSOR: 'SEARCH/SET_CURRENT_PAGE_CURSOR',
    SET_PREVIOUS_PAGES_CURSORS: 'SEARCH/SET_PREVIOUS_PAGES_CURSORS',
    SET_UPDATE_TRIGGERS: 'SEARCH/SET_UPDATE_TRIGGERS',
    SET_STATIC_OPTIONS: 'SEARCH/SET_STATIC_OPTIONS',
    SET_DEPARTMENT: 'SEARCH/SET_DEPARTMENT',
    SET_TOTAL_RESULTS: 'SEARCH/SET_TOTAL_RESULTS',
    SET_SELLER_FOR_SEARCH: 'SEARCH/SET_SELLER_FOR_SEARCH',
    SET_PAGES_COUNT: 'SEARCH/SET_PAGES_COUNT',
    SET_IS_FETCHING_PRODUCTS: 'SEARCH/SET_IS_FETCHING_PRODUCTS',
    SET_IS_FETCHING_AGGREGATIONS: 'SEARCH/SET_IS_FETCHING_AGGREGATIONS',
    SET_NAVIGATION_TYPE: 'SEARCH/SET_NAVIGATION_TYPE',
    SET_PAGINATION_WITH_URL_PARAMS: 'SEARCH/SET_PAGINATION_WITH_URL_PARAMS',
    RESET_PAGINATION: 'SEARCH/RESET_PAGINATION',
    SET_SEARCH_ID: 'SEARCH/SET_SEARCH_ID',
    SET_SEARCH_CONTEXT: 'SEARCH/SET_SEARCH_CONTEXT',
    SET_SELECTED_CONTEXT: 'SEARCH/SET_SELECTED_CONTEXT',
    SET_IS_HIGHLIGHTS_PANEL_VISIBLE: 'SEARCH/SET_IS_HIGHLIGHTS_PANEL_VISIBLE'
  },
  ACTIONS: {
    INITIAL_LOAD: 'SEARCH/INITIAL_LOAD',
    CHANGE_TERM: 'SEARCH/CHANGE_TERM',
    PAGINATE: 'SEARCH/PAGINATE',
    CHANGE_FILTER: 'SEARCH/CHANGE_FILTER',
    NAVIGATE_HISTORY: 'SEARCH/NAVIGATE_HISTORY',
    CHANGE_DEPARTMENT: 'SEARCH/CHANGE_DEPARTMENT',
    CHANGE_STATIC_OPTIONS: 'SEARCH/CHANGE_STATIC_OPTIONS',
    RELOAD: 'SEARCH/RELOAD'
  }
}
